var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "messages-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/messages-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messages-3_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7866 16.5333V21.96C20.7866 22.44 20.7333 22.8933 20.6133 23.3067C20.12 25.2667 18.4933 26.4933 16.2533 26.4933H12.6266L8.59996 29.1733C7.99996 29.5867 7.19996 29.1467 7.19996 28.4267V26.4933C5.83996 26.4933 4.70663 26.04 3.91996 25.2533C3.11996 24.4533 2.66663 23.32 2.66663 21.96V16.5333C2.66663 14 4.23996 12.2533 6.66663 12.0267C6.83996 12.0133 7.01329 12 7.19996 12H16.2533C18.9733 12 20.7866 13.8133 20.7866 16.5333Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.6666 20.7998C25.36 20.7998 26.7866 20.2398 27.7733 19.2398C28.7733 18.2532 29.3333 16.8265 29.3333 15.1332V8.33317C29.3333 5.19984 26.8 2.6665 23.6666 2.6665H12.3333C9.19996 2.6665 6.66663 5.19984 6.66663 8.33317V9.33317C6.66663 9.7065 6.95996 9.99984 7.33329 9.99984H16.2533C19.8666 9.99984 22.7866 12.9198 22.7866 16.5332V20.1332C22.7866 20.5065 23.08 20.7998 23.4533 20.7998H23.6666Z",
    fill: "#292D32"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.7f3c8745324770033d6ccb7b92e8f864.svg";
export { ForwardRef as ReactComponent };